module.exports = __webpack_public_path__ + "static/media/logo.e5db4964.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.svg
// module id = 326
// module chunks = 0